import { Box, DialogTitle, IconButton, Typography } from '@mui/material';
import { DialogButton } from './Button';

/** Material UI Icons. */
import CloseIcon from '@mui/icons-material/Close';

const DialogHeader = ({
    cursor = false,
    title = '',
    onClose,
    onSave = null,
    backgroundColor = '#003a52',
    saveDisabled = false,
    leftChildren,
    rightChildren,
    sx,
}) => {
    return (
        <DialogTitle
            id="draggable-dialog-title"
            sx={{
                backgroundColor: backgroundColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                height: '64px',
                boxShadow: 3,
                cursor: cursor ? 'move' : 'default',
                ...sx,
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}>
                <IconButton onClick={onClose} sx={{ mr: '12px' }}>
                    <CloseIcon sx={{ color: 'white', fontSize: '23px' }} />
                </IconButton>
                <Typography sx={{ fontWeight: 'bold', fontSize: '14px', color: 'white' }}>{title}</Typography>
                {leftChildren}
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}>
                {rightChildren}
                {onSave && (
                    <DialogButton text="SAVE" width="52px" onClick={onSave} additional={{ disabled: saveDisabled }} />
                )}
            </Box>
        </DialogTitle>
    );
};

export default DialogHeader;
